export const getComponentConfig = (axiosInstance, data) => {
    const url = `v1/config/component/${data.componentName}${data.paramString ? `?${data.paramString}` : ''}`;
    return axiosInstance.get(url);
};

export const postComponentAction = (axiosInstance, componentName, actionName, data) => {
    const url = `v1/config/component/${componentName}/action/${actionName}`;
    return axiosInstance.post(url, data);
};
